export const types = {
    LOAD_CAMPAIGN_REQUEST: "campaigns/LOAD_CAMPAIGN_REQUEST",
    LOAD_CAMPAIGN_SUCCESS: "campaigns/LOAD_CAMPAIGN_SUCCESS",
    LOAD_CAMPAIGN_FAILURE: "campaigns/LOAD_CAMPAIGN_FAILURE",

    LOAD_CAMPAIGN_IMAGE: "campaigns/LOAD_CAMPAIGN_IMAGE",

    REMOVE_CAMPAIGNS: "campaigns/REMOVE_CAMPAIGNS",

    DISMISS_CAMPAIGN_PERMANENT_REQUEST: "campaigns/DISMISS_CAMPAIGN_PERMANENT_REQUEST",
    DISMISS_CAMPAIGN_PERMANENT_SUCCESS: "campaigns/DISMISS_CAMPAIGN_PERMANENT_SUCCESS",
    DISMISS_CAMPAIGN_PERMANENT_FAILURE: "campaigns/DISMISS_CAMPAIGN_PERMANENT_FAILURE",

    DISMISS_CAMPAIGN: "campaigns/DISMISS_CAMPAIGN",

    LIST_CAMPAIGNS_REQUEST: "campaigns/LIST_CAMPAIGNS_REQUEST",
    LIST_CAMPAIGNS_SUCCESS: "campaigns/LIST_CAMPAIGNS_SUCCESS",
    LIST_CAMPAIGNS_FAILURE: "campaigns/LIST_CAMPAIGNS_FAILURE",

    SHOW_DISPLAY_MODAL: "campaigns/SHOW_DISPLAY_MODAL",
    CLOSE_DISPLAY_MODAL: "campaigns/CLOSE_DISPLAY_MODAL",
};

export const INITIAL_STATE = {
    fetching: false,
    items: [],
    displayModal: false,
    selectedCampaign: 0,
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case types.LOAD_CAMPAIGN_REQUEST:
            return {
                ...state,
                fetching: true,
            };

        case types.LOAD_CAMPAIGN_SUCCESS:
            return {
                ...state,
                fetching: false,
                items: [action.item],
            };

        case types.LOAD_CAMPAIGN_FAILURE:
            return { ...state, fetching: false };

        case types.REMOVE_CAMPAIGNS:
            return INITIAL_STATE;

        case types.DISMISS_CAMPAIGN_PERMANENT_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DISMISS_CAMPAIGN_PERMANENT_SUCCESS:
            return {
                ...state,
                displayModal: false,
                selectedCampaign: 0,
                items: [action.item],
            };
        case types.DISMISS_CAMPAIGN_PERMANENT_FAILURE:
            return {
                ...state,
                displayModal: false,
                selectedCampaign: 0,
            };
        case types.DISMISS_CAMPAIGN:
            return {
                ...state,
                displayModal: false,
                selectedCampaign: 0,
                items: [action.items[0] ? action.items[0].filter((item) => item.idCampaign !== action.idCampaign) : []],
            };
        case types.LIST_CAMPAIGNS_REQUEST:
            return {
                ...state,
                fetching: true,
            };

        case types.LIST_CAMPAIGNS_SUCCESS:
            return {
                ...state,
                fetching: false,
                items: [action.item],
            };

        case types.LIST_CAMPAIGNS_FAILURE:
            return { ...state, fetching: false };

        case types.SHOW_DISPLAY_MODAL:
            return { ...state, displayModal: true, selectedCampaign: action.idCampaign };

        case types.CLOSE_DISPLAY_MODAL:
            return { ...state, displayModal: false, selectedCampaign: 0 };
        default:
            return state;
    }
};

export const actions = {
    loadCampaign: (section) => ({
        type: types.LOAD_CAMPAIGN_REQUEST,
        section,
    }),
    removeCampaigns: () => ({
        type: types.REMOVE_CAMPAIGNS,
    }),
    dismissPermanentCampaign: (idCampaign, section) => ({
        type: types.DISMISS_CAMPAIGN_PERMANENT_REQUEST,
        idCampaign,
        section,
    }),
    dismissCampaign: (idCampaign, items) => ({
        type: types.DISMISS_CAMPAIGN,
        idCampaign,
        items,
    }),
    listCampaignsBySection: (section) => ({
        type: types.LIST_CAMPAIGNS_REQUEST,
        section,
    }),
    showDisplayModal: (idCampaign) => ({
        type: types.SHOW_DISPLAY_MODAL,
        idCampaign,
    }),
    closeDisplayModal: () => ({
        type: types.CLOSE_DISPLAY_MODAL,
    }),
};

export const selectors = {
    getCampaigns: ({ campaigns }) => campaigns.items,
    getFetching: ({ campaigns }) => campaigns.fetching,
    getDisplayModal: ({ campaigns }) => campaigns.displayModal,
    getSelectedCampaign: ({ campaigns }) => campaigns.selectedCampaign,
};
